import { InitialGroupOrderComparatorParams } from 'ag-grid-community';

export const stageComparator = (params: InitialGroupOrderComparatorParams): number => {
  const a = params.nodeA.data?.stage.sortOrder ?? -1;
  const b = params.nodeB.data?.stage.sortOrder ?? -1;

  return a - b;
};
